import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import ActionUpdate from '@material-ui/icons/Update';
import classnames from 'classnames';
import { translate, crudDelete, startUndoable } from 'ra-core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import dataProviderFactory from "../dataProvider";
import {  UPDATE } from 'react-admin'
import { Button, TextInput } from 'react-admin';

const styles = (theme) => ({
  deleteButton: {
    color: theme.palette.error.main,
    '&:hover': {
      backgroundColor: fade(theme.palette.error.main, 0.12),
      // Reset on mouse devices
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }
  }
});

const patterEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
let statec = false
class CambioEmail extends Component {
  state = {
    showDialog: false,
    emailNew: 'null',
    errorEmail: false,
    value: ""
  };

  async metodoUpdateEmail(data) {
    const { record } = this.props;
    record["dataEmail"] = this.state.emailNew;
    //const emailNew = this.state.emailNew
    const dataProvider = await dataProviderFactory("rest");
    const bodyRequest = {
      id: record.id, data: {
        id: record.id,
        emailNew: record.dataEmail
      }
    };
    dataProvider(UPDATE, "clients/updateEmail", bodyRequest)
      .then((response) => {
        //console.log(response);
        this.setState({ refunded: true });
        this.setState({ showDialog: false });
        window.location.reload(false);
        this.setState({ errorEmail: false });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  handleUpdateEmail = (event) => {
    event.preventDefault();
    console.log('clicko')
    console.log(statec)
    const { undoable, emailNew, state, record } = this.props;
    
      const data = {
        id: record.id,
        emailNew: this.state.emailNew
      }
      if(statec === true){
        this.metodoUpdateEmail(data)
      }
      else{
        this.setState({ errorEmail: false });
      }
     
    
  };

  handleBlur = (element, type) => {
    const value = element.target.value.trim().toLowerCase();
    const isValidEmail = patterEmail.test(value);
    if (isValidEmail) 
      this.setState({errorEmail: true})
    else 
      this.setState({errorEmail: false})
  }

  handleChange = (element, type) => {
    const value = element.target.value.trim().toLowerCase();
    const isValidEmail = patterEmail.test(value);
    if (isValidEmail) {
      this.setState({
        [type]: element.target.value,
      });
      this.setState({ errorEmail: false });
      console.log('correo valido')
      console.log(this.state.errorEmail)
      statec = true

    }
    else {
      console.log('correo no valido')
      this.setState({ errorEmail: true });
    }
  };
  renderConfirmError = () => {
    if ( this.state.errorEmail ) {
      return (
        <div>
          <span style={{ color: "red", fontSize: "13px" }}>
            Invalid email format
            &nbsp;<b>!</b>
          </span>
        </div>
      );
    }  
    return null;
  }

  render() {
    const { showDialog } = this.state;
    const { label = 'ra.action.update', classes = {}, className, resource, record } = this.props;
    return (
      <Fragment>
        <Button onClick={this.handleClick} label={label} className={classnames('update-button', classes.deleteButton, className)} key="button">
          <ActionUpdate />
        </Button>
        <Dialog fullWidth open={showDialog} onClose={this.handleCloseClick} aria-label="Want to update credentials?">
          <DialogTitle>Are you sure you want to update this credentials?</DialogTitle>
          <DialogContent>
            <div>
              Your answer will be recorded.
            </div>
            <TextInput label="New Email" name="emailNew" /*onBlur={(e) => this.handleBlur(e, "emailNew")}*/
              onChange={(e) =>
                this.handleChange(e, "emailNew")
              }
              value={this.state.emailNew} />
              {this.renderConfirmError()}
            {/* <FunctionField
              render={() => {
                
              }}
            /> */}
          </DialogContent>
          <DialogActions>
            <Button onClick={(e) => this.handleUpdateEmail(e)} 
                  disabled={ this.state.errorEmail } 
                  label={label} 
                  className={classnames('ra-update-button', classes.deleteButton, className)} 
                  key="button">
              <ActionUpdate />
            </Button>
            <Button label="Return" /* label="ra.action.cancel" */ onClick={this.handleCloseClick}>
              <ArrowBackIcon />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

CambioEmail.propTypes = {
  basePath: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  dispatchCrudDelete: PropTypes.func.isRequired,
  label: PropTypes.string,
  record: PropTypes.object,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.func]),
  resource: PropTypes.string.isRequired,
  startUndoable: PropTypes.func,
  translate: PropTypes.func,
  undoable: PropTypes.bool
};

CambioEmail.defaultProps = {
  redirect: 'list',
  undoable: true
};

export default compose(
  connect(
    null,
    { startUndoable, dispatchCrudDelete: crudDelete }
  ),
  translate,
  withStyles(styles)
)(CambioEmail);



// WEBPACK FOOTER //
// ./src/components/CambioEmail.js